const ACCESS_TOKEN_KEY = 'token'
const REFRESH_TOKEN_KEY = 'refresh_token'

/**
 * Retrieves the JWT access token from localStorage
 * @returns The JWT access token string or empty string if not found
 */
export const getAccessToken = (): string => {
  return localStorage.getItem(ACCESS_TOKEN_KEY) || ''
}

/**
 * Sets the JWT access token in localStorage
 * @param token - The access token to store
 */
export const setAccessToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

/**
 * Removes the JWT access token from localStorage
 */
export const removeAccessToken = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}

/**
 * Retrieves the JWT refresh token from localStorage
 * @returns The JWT refresh token string or empty string if not found
 */
export const getRefreshToken = (): string => {
  return localStorage.getItem(REFRESH_TOKEN_KEY) || ''
}

/**
 * Sets the JWT refresh token in localStorage
 * @param token
 */
export const setRefreshToken = (token: string): void => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token)
}

/**
 * Removes the JWT refresh token from localStorage
 */
export const removeRefreshToken = (): void => {
  localStorage.removeItem(REFRESH_TOKEN_KEY)
}

/**
 * Sets both access and refresh tokens in localStorage
 * @param accessToken
 * @param refreshToken
 */
export const setAuthTokens = (
  accessToken: string,
  refreshToken: string
): void => {
  setAccessToken(accessToken)
  setRefreshToken(refreshToken)
}

/**
 * Clear all auth-related data from localStorage
 * Useful for logout functionality
 */
export const clearAuthData = (): void => {
  removeAccessToken()
  removeRefreshToken()
}
